import { api, client_code } from '@/utils'

import {
  Params,
  RedeemBookingPayload,
  RedeemBookingResponse,
  Response,
  ResponseDetail,
  Service
} from '.'

const fetch = async (params: Params): Promise<Response> => {
  try {
    const res = await api.get<Response>('redeem/product', { params: { ...params, client_code } })
    return res.data
  } catch (e) {
    throw e
  }
}

const fetchDetail = async (id: number): Promise<ResponseDetail> => {
  try {
    const res = await api.get<ResponseDetail>(`redeem/product/${id}`, { params: { client_code } })
    return res.data
  } catch (e) {
    throw e
  }
}

const book = async (payload: RedeemBookingPayload): Promise<RedeemBookingResponse> => {
  try {
    const { client_code: payloadClientCode, ...rest } = payload
    const code_client = payloadClientCode || client_code
    // loyal.id `redeem/book` expects the client identifier as `code_client`,
    // not `client_code` (see fjgs booking_redeem/service.ts). Sending only
    // `client_code` makes the backend respond "client code is required".
    const res = await api.post<RedeemBookingResponse>('redeem/book', {
      ...rest,
      code_client,
      client_code: code_client
    })
    return res.data
  } catch (e) {
    throw e
  }
}

export const service: Service = {
  fetch,
  fetchDetail,
  book
}
